import React, { useState } from "react"

import { Flex, Menu } from "@mantine/core"
import { Icon } from "@/components/Icon"

import classes from "@/components/CardSquare/DropdownSelect/DropdownSelect.module.css"

export const DropdownSelect = ({ icon, label, options }) => {
    const [selected, setSelected] = useState({ label: label, icon: icon })

    return (
        <Menu position="bottom-start">
            <Menu.Target>
                <div className={classes.button}>
                    <Icon icon={selected.icon} iconFamily="far" />
                    <span>{selected.label}</span>
                    <Icon icon="angle-down" />
                </div>
            </Menu.Target>

            <Menu.Dropdown>
                {options.map((option) => (
                    <Menu.Item
                        key={option.label}
                        onClick={() => {
                            setSelected({ label: option.text, icon: option.icon })
                            option.onClick()
                        }}
                    >
                        <Flex gap=".375rem">
                            <Icon icon={option.icon} iconFamily="far" />
                            {option.text}
                        </Flex>
                    </Menu.Item>
                ))}
            </Menu.Dropdown>
        </Menu>
    )
}
